// Manager de toasts avec queue
(() => {
    const host = document.getElementById('toast-host') || (() => {
        const h = document.createElement('div'); h.id = 'toast-host'; h.className = 'toast-host';
        document.body.appendChild(h); return h;
    })();
    const queue = []; let showing = false;

    function render({ msg, variant='info', actionText, onAction, timeout=3000 }) {
        const el = document.createElement('div');
        el.className = `toast toast--${variant}`;
        el.innerHTML = `<span>${msg}</span>` + (actionText ? ` <button class="toast__action">${actionText}</button>` : '');
        host.appendChild(el);

        const close = () => { el.remove(); showing = false; next(); };
        const btn = el.querySelector('.toast__action');
        let t = setTimeout(close, timeout);
        btn?.addEventListener('click', () => { clearTimeout(t); onAction?.(); close(); });
        el.addEventListener('mouseenter', () => clearTimeout(t));
        el.addEventListener('mouseleave', () => t = setTimeout(close, 1200));
    }

    function next() { if (showing || queue.length === 0) return; showing = true; render(queue.shift()); }

    window.toast = (msg, opts={}) => { queue.push({ msg, ...opts }); next(); };
})();
